module.exports = __webpack_public_path__ + "z.no1.3dfef8dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/z.no1.jpg
// module id = wV18
// module chunks = 0